import { Injectable } from '@angular/core';
import { CanDeactivate, ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { AssignService } from '../services/assign.service';

@Injectable({
  providedIn: 'root'
})
export class AssignChangesGuard implements CanDeactivate<unknown> {
  constructor(private assignService: AssignService){}
  canDeactivate(
    component: unknown,
    currentRoute: ActivatedRouteSnapshot,
    currentState: RouterStateSnapshot,
    nextState?: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
      if (this.assignService.isDirtyChanges()){
        if (confirm('שינויים שבוצעו לא נשמרו.\nבטוח שברצונך לצאת?')){
          this.assignService.clearChanges();
          return true;
        } else {
          return false;
        }
      }
    return true;
  }
  
}
